<template>
  <div></div>
  <!-- <v-overlay :value="hold" :opacity="0.3">
    <v-card
      color="blue darken-2"
      dark width="300">
      <v-card-text>
        Yükleniyor... Lütfen Bekleyiniz.
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-overlay> -->
</template>

<script>
export default {
  name: 'Loading',
  props: ['hold'],
};
</script>
